import { Box, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { IconMessageCircle, IconNavigation, IconShieldCheck, IconSparkles } from '@tabler/icons-react';

const discoverySignals = [
  { value: '真实', label: '发师实拍作品集', tone: 'gold' },
  { value: '直聊', label: '无中介随时发图', tone: 'terracotta' },
  { value: '灵活', label: '到店或上门做辫', tone: 'forest' },
] as const;

export function AuthStoryPanel() {
  return (
    <Stack className="auth-story-panel" gap={22} visibleFrom="lg">
      <Stack gap="sm">
        <Group className="auth-story-panel__eyebrow" gap={8} wrap="nowrap">
          <IconSparkles size={15} stroke={1.8} />
          <Text size="xs" fw={700}>养新辫 · 锁发根 · 紧发扭发 · 接长与排毒</Text>
        </Group>
        <Title order={1} className="auth-story-panel__title">
          懂你的脏辫
          <span>就在身边的手艺人</span>
        </Title>
        <Text className="auth-story-panel__copy">
          不用四处打听谁的手艺好。在地图上一眼看到身边的脏辫师，直接私信拍张发根和发长给发师看，沟通清楚、聊得投缘再约时间
        </Text>
      </Stack>

      <Box className="auth-consultation-preview" aria-label="发图咨询示例">
        <Group justify="space-between" className="auth-consultation-preview__header">
          <Group gap={8}>
            <span className="auth-live-dot" />
            <Text size="xs" fw={800}>发图直聊</Text>
          </Group>
          <Text size="xs" ff="var(--mantine-font-family-monospace)">约之前先聊聊发根状态</Text>
        </Group>
        <Stack gap="sm" mt="md">
          <Group gap="xs" align="flex-start" wrap="nowrap">
            <Box className="auth-consultation-preview__avatar">发友</Box>
            <Text className="auth-consultation-preview__message" size="xs">
              嗨！刚发了两张我发根新生发和发冠的实拍。这周六方便做一次锁发（Interlocking）维护吗？
            </Text>
          </Group>
          <Group gap="xs" align="flex-start" wrap="nowrap" justify="flex-end">
            <Text className="auth-consultation-preview__message auth-consultation-preview__message--reply" size="xs">
              你好 Devon！你的发根养得很干净。锁发加做一次苹果醋洗护大概 2.5 小时，我周六下午 1:30 工作室正好有空
            </Text>
            <Box className="auth-consultation-preview__avatar auth-consultation-preview__avatar--loctician">发师</Box>
          </Group>
        </Stack>
        <Group justify="space-between" mt="md" className="auth-consultation-preview__footer">
          <Group gap={6}><IconShieldCheck size={14} /><Text size="xs">发师真人与实拍作品</Text></Group>
          <Group gap={6}><IconNavigation size={14} /><Text size="xs">离你几英里一目了然</Text></Group>
        </Group>
      </Box>

      <SimpleGrid cols={3} spacing="sm">
        {discoverySignals.map((signal) => (
          <Box key={signal.value} className="auth-discovery-signal" data-tone={signal.tone}>
            <Group gap={6} justify="center">
              {signal.value === '直聊' && <IconMessageCircle size={14} stroke={1.8} />}
              <Text fw={900} ff="var(--mantine-font-family-monospace)">{signal.value}</Text>
            </Group>
            <Text size="xs">{signal.label}</Text>
          </Box>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
